function fixMailtoLinks() {
	document.querySelectorAll('a[href^="mailto:"]').forEach(a => {
		const href = a.getAttribute('href');
		const bodyMatch = href.match(/body=([^"]+)/);

		if (bodyMatch) {
			const originalBody = decodeURIComponent(bodyMatch[1]);
			const encodedBody = encodeURIComponent(originalBody);
			const newHref = href.replace(/body=([^"]+)/, 'body=' + encodedBody);
			a.setAttribute('href', newHref);
		}
	});
}

const observer = new MutationObserver(() => {
	fixMailtoLinks();
});

observer.observe(document.body, {
	childList: true,
	subtree: true,
});
